import { WSList, WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { FilterableTablePayables } from "../components/TablePayables/FilterableTablePayables";

export const RoutePayablesDrafts: React.FC = () => {
  useBrowserPageTitle("Draft Payables");
  const history = useHistory();

  return (
    <WSPage
      title="Draft Payables"
      breadcrumb={{
        label: "Payables to approve",
        icon: "arrow-left",
        onClick: () => history.push("/member/invoices/payables/to-approve")
      }}
    >
      <WSList gap="2XL">
        <FilterableTablePayables
          tab="draft"
          showDownloadCsv
          bulkActions={["open", "cancel"]}
          visibleColumns={{
            payee: true,
            payableNumber: true,
            amount: true,
            dueDate: true,
            openedAt: true,
            status: true
          }}
          visibleFilters={{
            payeeId: true,
            openedDateRange: true,
            dueDateRange: true,
            bulkBatchId: true
          }}
          emptyState={{
            standart: "No unsent payables."
          }}
        />
      </WSList>
    </WSPage>
  );
};
